import { CONFIRMATION_REDIRECT_OPTIONS } from './confirmation-mini-app.const';

export const HUBSPOT_SCHEDULER_SETTINGS_CONFIRMATION_OPTIONS = [
	{
		title: 'Show a confirmation icon briefly, and then continue to the next step',
		value: CONFIRMATION_REDIRECT_OPTIONS.withAnimation,
	},
	{
		title: 'No confirmation (continue to the next step immediately)',
		value: CONFIRMATION_REDIRECT_OPTIONS.withoutAnimation,
	},
	{
		title: 'Show HubSpot`s confirmation (the user will need to click to continue)',
		value: CONFIRMATION_REDIRECT_OPTIONS.defaultPage,
	},
];
